// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const NDC_CREATE_PROTEINS_FROM_DATASET_STEP_SHAPES = [
  {
    stepType: PipelineStepType.NDC_CREATE_PROTEINS_FROM_DATASET,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      antibodySchemaId: {
        kind: 'domain',
        required: true,
        types: [
          'ENTITY_SCHEMA'
        ]
      },
      folderId: {
        kind: 'domain',
        required: true,
        types: [
          'FOLDER'
        ]
      },
      geneticCode: {
        kind: 'enum',
        required: true,
        choices: [
          'STANDARD',
          'VERTEBRATE_MITOCHONDRIAL',
          'YEAST_MITOCHONDRIAL',
          'MOLD_PROTOZOAN_COELENTERATE_MITOCHONDRIAL_MYCOPLASMA_SPIROPLASMA',
          'INVERTEBRATE_MITOCHONDRIAL',
          'CILIATE_DASYCLADACEAN_HEXAMITA_NUCLEAR',
          'ECHINODERM_FLATWORM_MITOCHONDRIAL',
          'EUPLOTID_NUCLEAR',
          'BACTERIAL_ARCHAEAL_PLANT_PLASTID',
          'ALTERNATIVE_YEAST_NUCLEAR',
          'ASCIDIAN_MITOCHONDRIAL',
          'ALTERNATIVE_FLATWORM_MITOCHONDRIAL',
          'CHLOROPHYCEAN_MITOCHONDRIAL',
          'TREMATODE_MITOCHONDRIAL',
          'SCENEDESMUS_OBLIQUUS_MITOCHONDRIAL',
          'THRAUSTOCHYTRIUM_MITOCHONDRIAL',
          'RHABDOPLEURIDAE_MITOCHONDRIAL',
          'CANDIDATE_DIVISION_SR1_GRACILIBACTERIA',
          'PACHYSOLEN_TANNOPHILUS_NUCLEAR',
          'KARYORELICT_NUCLEAR',
          'CONDYLOSTOMA_NUCLEAR',
          'MESODINIUM_NUCLEAR',
          'PERITRICH_NUCLEAR',
          'BLASTOCRITHIDIA_NUCLEAR',
          'CEPHALODISCIDAE_MITOCHONDRIAL_UAA_TYR'
        ]
      },
      germlineId: {
        kind: 'string',
        required: true
      },
      aaPairSchemaId: {
        kind: 'domain',
        required: true,
        types: [
          'ENTITY_SCHEMA'
        ]
      },
      dnaDomainSchemaId: {
        kind: 'domain',
        required: false,
        types: [
          'ENTITY_SCHEMA'
        ]
      },
      dnaChainSchemaId: {
        kind: 'domain',
        required: false,
        types: [
          'ENTITY_SCHEMA'
        ]
      },
      dnaPairSchemaId: {
        kind: 'domain',
        required: false,
        types: [
          'ENTITY_SCHEMA'
        ]
      },
      componentFormatType: {
        kind: 'enum',
        required: false,
        choices: [
          'DOMAINS',
          'CHAINS',
          'VARIABLE_PAIRS'
        ]
      },
      documentId: {
        kind: 'string',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
